module.exports = __webpack_public_path__ + "img/eye-in-gdpr-en.ba33848c.png";